/**
 * Styled Components - Created by david on 27/03/18.
 */
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-flow: column;
  max-width: 1444px;
  padding-inline: 70px;
  justify-self: center;
  width: 100%;
  padding-block: 24px;
  @media (max-width: 768px) {
    padding-inline: var(--spacing-16);
  }
`

export const BackButton = styled.div`
  display: flex;
  padding: 11px var(--spacing-16);
  justify-content: center;
  align-items: center;
  border: 1px solid var(--neutral-muted);
  color: var(--color-neutral-body);
  font: 600 12px Barlow;
  text-transform: uppercase;
  width: fit-content;
  background-color: white;
  .anticon {
    margin-right: var(--spacing-6);
  }
  transition: background-color 0.3s;
  &:hover {
    cursor: pointer;
    background-color: transparent;
  }
`

export const Title = styled.div`
  margin-top: var(--spacing-24);
  color: var(--neutral-darkest);
  font: 600 32px/38px "Barlow Semi Condensed";
  #eyebrow {
    color: var(--neutral-secondary);
    font: 600 12px/20px Barlow;
    letter-spacing: 1.12px;
    text-transform: uppercase;
  }
  @media (max-width: 768px) {
    padding-inline: var(--spacing-16);
    font-size: 24px;
  }
`

export const CardsContainer = styled.div`
  font-family: Avenir;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  @media (max-width: 698px) {
    flex-flow: column-reverse;
  }
`

export const Card = styled.div`
  display: flex;
  flex-flow: column;
  max-width: 344px;
  background: white;
  border-radius: 6px;
  box-shadow: 1px 2px 4px -2px #acacac;
  outline: 1px solid #d8d8d8;
  transition: box-shadow .25s, outline .25s, transform .25s;
  &:first-child {
    margin-right: 16px;
  }
  .cardBody {
    padding: 20px;
    display: flex;
    flex-flow: column;
    flex: 1;
  }
  .subTag {
    font-size: 11px;
    background: #E8E5E5;
    width: fit-content;
    border-radius: 25px;
    padding: 2px 14px;
    font-weight: bold;
  }
  .option {
    font-size: 20px;
    margin-top: 20px;
    color: #302628;
  }
  .smallDesc {
    color: #8F8889;
  }
  .cardFeatures {
    font-weight: 500;
    color: #302628;
    line-height: 22px;
    & > span {
      color: #17b10c;
    }
  }
  &:hover {
    box-shadow: 1px 2px 6px 1px #acacac;
    transform: scale(1.005);
    cursor: pointer;
    .btn {
      color: #302628;
      background: white;
      outline: 1px solid #302628;
    }
  }
  @media (max-width: 698px) {
    &:first-child {
      margin-right: 0px;
      margin-top: 16px;
    }
    .subTag {
      font-size: 10px;
    }
    .option {
      margin-top: 12px;
      font-size: 18px;
    }
    .smallDesc {
      font-size: 12px;
    }
  }
  @media (max-width: 360px) {
    .cardBody {
      padding: 20px 16px;
    }
    .cardFeatures {
      font-size: 12px;
    }
  }
`

export const BannerCard = styled.img`
  width: 100%;
  border-radius: 6px 6px 0 0;
`

export const CardDesc = styled.div`
  margin-block: 20px;
  font-size: 14px;
  line-height: 20px;
  flex: 1;
  display: flex;
  align-items: center;
  @media (max-width: 698px) {
    margin-block: 12px;
  }
  @media (max-width: 360px) {
    font-size: 12px;
  }
`

export const CardBtn = styled.div`
  font-size: 16px;
  background: #302628;
  border-radius: 25px;
  text-align: center;
  color: white;
  padding: 8px 4px;
  font-weight: 500;
  margin-top: 20px;
  transition: background .25s, outline .25s, color .25s;
`

export const Cards = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  flex-wrap: nowrap;
  gap: 16px;
  margin-top: var(--spacing-24);
  @media (max-width: 768px) {
    flex-wrap: wrap;
  }
`

export const CardOption = styled.div`
  display: flex;
  flex-flow: column;
  padding: 32px 24px;
  max-width: 422px;
  width: 100%;
  color: var(--neutral-body);
  border: 1px solid var(--neutral-border-med);
  background: var(--neutral-white);
  box-shadow: 0 1px 2px 0 rgba(10, 10, 9, 0.08);
  .icon {
    max-width: 58px;
    max-height: 58px;
    object-fit: contain;
  }
  .tag {
    margin-top: var(--spacing-24);
    border-radius: var(--spacing-4);
    background: var(--neutral-border-light);
    width: fit-content;
    font: 600 12px Barlow;
    letter-spacing: 1.12px;
    text-transform: uppercase;
    padding: var(--spacing-6) var(--spacing-8);
    &[data-tag="Professional"] {
      background-color: var(--neutral-darkest);
      color: white;
    }
    &[data-tag="New!"] {
      background-color: var(--accent-red);
      color: white;
    }
  }
  .title {
    margin-top: var(--spacing-12);
    color: var(--neutral-darkest);
    font: 400 22px / 30px var(--font-barlow-semi-condensed);
    letter-spacing: 0.44px;
  }
  .subtitle {
    margin-top: var(--spacing-12);
    color: var(--neutral-secondary);
    font: 400 12px/20px var(--font-inter);
  }
  .description {
    font: 400 12px / 20px var(--font-inter);
    margin-block: var(--spacing-24) var(--spacing-16);
  }
  transition: transform .25s, border-color .25s, box-shadow .25s;
  &:hover {
    transform: scale(1.02);
    border-color: var(--neutral-darkest);
    box-shadow: 4.025px 4.025px 10.063px 0 rgba(10, 10, 9, 0.12);
  }
  .more-options {
    display: none;
    color: var(--neutral-darkest);
    font: 14px var(--font-inter);
    text-align: center;
    padding-block: var(--spacing-24) var(--spacing-8);
  }
  .topSection {
    display: flex;
    flex-flow: column;
    flex: 1;
    transition: height .3s ease-in;
  }
  @media (max-width: 768px) {
    .topSection {
      height: 0;
      overflow-y: hidden;
      flex: unset;
    }
    .show {
      display: block;
    }
    max-width: 100%;
    padding: var(--spacing-24);
    .tag {
      margin-top: var(--spacing-20);
    }
    .description {
      margin-block: var(--spacing-16);
    }
  }
`

export const Features = styled.ul`
  padding-left: var(--spacing-16);
  font: 14px/22px var(--font-inter);
  margin-bottom: var(--spacing-24);
  flex: 1;
  li {
    margin-top: var(--spacing-8);
  }
  li::marker {
    content: "➔  ";
    color: var(--neutral-muted);
    font-size: 11px;
  }
  li:first-child {
    color: var(--accent-green);
    font-weight: 600;
    margin-top: 0;
    ::marker {
      color: var(--accent-green);
    }
  }
  @media (max-width: 768px) {
    margin-bottom: var(--spacing-16);
  }
`

export const CardFooter = styled.div`
  background: var(--neutral-lightest-block);
  padding: var(--spacing-16);
  font: 12px/20px var(--font-inter);
  .footerTitle {
    color: var(--neutral-muted);
    font: 500 12px/20px var(--font-barlow);
    text-transform: uppercase;
    margin-bottom: var(--spacing-4);
  }
`

export const ButtonOption = styled.div`
  margin-top: var(--spacing-24);
  background: var(--neutral-darkest);
  color: var(--neutral-white);
  text-align: center;
  padding: var(--spacing-14);
  text-transform: uppercase;
  font: 12px var(--font-barlow);
  letter-spacing: 1.12px;
  transition: opacity .25s;
  .anticon {
    font-size: 14px;
    margin-right: 10px;
  }
  &:hover {
    opacity: 0.8;
    cursor: pointer;
  }
  @media (max-width: 768px) {
    margin-top: var(--spacing-16);
  }
`

export const InfoDiv = styled.div`
  display: flex;
  width: 100%;
  margin-top: var(--spacing-16);
  border: var(--border-regular) solid var(--neutral-border-med);
  background: var(--neutral-white);
  padding: var(--spacing-16) var(--spacing-24);
  .anticon {
    background: var(--neutral-border-light);
    border-radius: 50%;
    align-self: center;
    font-size: 26px;
    padding: 10px;
    margin-right: var(--spacing-24);
    color: var(--neutral-secondary);
  }
  #titleQuestion {
    color: #302628;
    font: 600 20px / 26px var(--font-barlow-semi-condensed);
    letter-spacing: 0.64px;
  }
  #descriptionQuestion {
    color: #817E7E;
    font: 16px/24px var(--font-inter);
  }
  #linkToContact {
    border: var(--border-regular) solid var(--neutral-muted);
    display: flex;
    max-width: 304px;
    width: 100%;
    align-self: center;
    padding: 13px var(--spacing-16);
    justify-content: center;
    align-items: center;
    color: var(--neutral-body);
    font: 600 12px var(--font-barlow);
    letter-spacing: 1.12px;
    text-transform: uppercase;
    transition: border .25s, color .25s;
    :hover {
      cursor: pointer;
      border: var(--border-regular) solid var(--neutral-darkest);
      color: var(--neutral-darkest);
    }
  }
  @media (max-width: 768px) {
    flex-flow: column;
    padding: var(--spacing-16);
    .anticon {
      margin-right: 0;
      margin-bottom: 28px;
    }
    #titleQuestion {
      text-align: center;
    }
    #descriptionQuestion {
      text-align: center;
      font-size: 15px;
    }
    #linkToContact {
      margin-top: var(--spacing-24);
    }
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/DesignPaths/styledComponents.tsx